<template>
    <div class="com-footer">
        <div class="footer">
            <div class="map">
                <div class="con clearfix">
                    <!--footer 导航列表-->
                    <div class="left clearfix">
                        <dl v-for="(item, index) in footList">
                            <dt>{{ item.title }}</dt>
                            <dd v-for="link in item.path">
                                <a :href="link.url">{{ link.name }}</a>
                            </dd>
                        </dl>
                    </div>
                    <!--link跳转-->
                    <div class="footer-link clearfix">
                        <span class="sensoro-icon"></span>
                        <ul class="clearfix">
                            <li
                                v-for="(icon, index) in footIcon"
                                :index="index"
                            >
                                <a :href="icon.iconUrl" target="_blank">
                                    <img :src="icon.iconImg" alt="" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--公司信息-->
        <footer>
            <div class="con">
                <div class="vct">
                    <div class="inner">
                        <div class="mark">
                            <p>
                                Copyright<span id="currentYear">
                                    {{ currentYear }} ©
                                </span>
                                by Sensoro Co., Ltd. iBeacon is a trademark of
                                Apple Inc.
                                <a
                                    class="reg"
                                    href="http://www.beian.miit.gov.cn/"
                                    target="_blank"
                                    >京ICP备18013471号-1</a
                                >
                                <span> 版权所有:北京升哲科技有限公司</span>
                            </p>
                        </div>
                        <div class="others">
                            <div class="country">
                                <span class="sensoro-globe"></span>
                                <a class="name" href="/zh/index">中文 </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: "mFooter",
    created() {},
    data() {
        return {
            footList: [
                {
                    title: "Products",
                    path: [
                        { url: "/en/Alpha", name: "Alpha" },
                        { url: "/en/Beacons", name: "Beacons" },
                    ],
                },
                {
                    title: "Insights",
                    path: [
                        { url: "/en/case", name: "Case Studies" },
                        { url: "/en/newsList", name: "Media" },
                    ],
                },
                {
                    title: "About",
                    path: [
                        { url: "/en/about", name: "About us" },
                        { url: "/en/contact", name: "Contact" },
                    ],
                },
                {
                    title: "Support",
                    path: [
                        { url: "/en/download", name: "Download" },
                        {
                            url: "https://sensoro.zendesk.com/hc/en-us",
                            name: "Q&A",
                        },
                        { url: "/en/developer", name: "Developer" },
                    ],
                },
            ],
            footIcon: [
                {
                    iconUrl: "https://www.facebook.com/sensoroglobal/",
                    iconImg: "/static/image/common/facebook@2x.png",
                },
                {
                    iconUrl: "https://www.linkedin.com/company/sensoro-inc./",
                    iconImg: "/static/image/common/LinkedIn@2x.png",
                },
                {
                    iconUrl: "https://twitter.com/SENSOROGLOBAL",
                    iconImg: "/static/image/common/Twitter@2x.png",
                },
                {
                    iconUrl: "https://www.github.com/sensoro",
                    iconImg: "/static/image/common/GitHub@2x.png",
                },
                // {
                //     iconUrl:'',
                //     iconImg:'/static/image/common/instagram@2x.png'
                // }
            ],
            currentYear: " " + new Date().getFullYear(),
        };
    },
    methods: {
        // returnTop: function (toHash) {
        //     document.querySelector("toHash").scrollIntoView(true);
        // }
    },
};
</script>

<style scoped lang="less">
.footer {
    /*临时*/
    /*margin-top: 200px;*/
    /**/
    background: #252525;

    .map {
        width: 1640px;
        margin: 0 auto;
        padding-top: 48px;
        border-bottom: 1px solid #4e4f51;
        .left {
            /*width: 83.333%;*/
            /*margin-bottom: 30px;*/
            display: flex;
            justify-content: space-between;
            /*justify-items: center;*/
        }
        dl {
            /*width: 25%;*/
            color: #fff;
            dt {
                line-height: 26px;
                font-size: 18px;
                margin-bottom: 32px;
            }
            dd {
                /*width: 40%;*/
                line-height: 22px;
                margin-bottom: 16px;
                a {
                    font-size: 14px;
                    color: #b7b7b7;
                    &:hover {
                        color: #fff;
                    }
                }
            }
        }
        .footer-link {
            height: 60px;
            .sensoro-icon {
                display: block;
                float: left;
                width: 75px;
                height: 100%;
                background: url("../assets/images/common/logo_nav@2x.png")
                    no-repeat center;
                background-size: 100%;
            }
            ul {
                float: right;
                /*width: 125px;*/
                margin-left: -25px;
                display: flex;
                li {
                    float: left;
                    flex: 1;
                    line-height: 60px;
                    text-align: right;
                    img {
                        display: inline-block;
                        vertical-align: middle;
                        width: 50%;
                    }
                }
            }
        }
    }
    .right {
        float: right;
        height: 100%;
    }
}

//=====footer company mes====
footer {
    height: 86px;
    background-color: #252525;
    color: #fff;
    .con {
        width: 1640px;
        margin: 0 auto;
        height: 100%;
    }
    .mark,
    .others {
        height: 74px;
        line-height: 74px;
    }
    .inner {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .mark {
        word-wrap: break-word;
        width: 70%;
        padding-top: 16px;
        .brand {
            background-size: contain;
        }
        p {
            /*margin-top: 3px;*/
            line-height: 22px;
            color: #b6b6b6;
            font-size: 14px;
        }
        .reg {
            text-decoration: none;
            color: #b6b6b6;
        }
    }

    .others {
        font-size: 14px;
        color: #b7b7b7;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
    }
}

.country {
    padding-top: 16px;
    height: 100%;
    font-size: 14px;
    line-height: 22px;
    vertical-align: top;
    display: flex;
    .name {
        padding-left: 10px;
        color: #fff;
    }
    img {
        display: inline-block;
        vertical-align: top;
    }
}

.sensoro-arrow-down {
    font-size: 12px;
    cursor: pointer;
}

.sensoro-globe {
    display: inline-block;
    //font-size: 18px;
    top: 2px;
    width: 20px;
    height: 20px;
    background: url("../assets/images/common/yuyan@2x.png") no-repeat center;
    background-size: 100%;
}

a:hover {
    color: inherit;
    text-decoration: none;
}

.mark {
    background: none;
    padding: inherit;
}

@media screen and (max-width: 1680px) {
    @autoWidth: 1256px;
    .com-footer {
        width: 100%;
        min-width: @autoWidth;
    }
    .footer .map,
    footer .con {
        width: 1216px;
        margin: 0 auto;
    }

    /*.footer {*/
    /*.map {*/
    /*dl {*/
    /*dd {*/
    /*!*width: 65%;*!*/
    /*}*/
    /*}*/
    /*}*/
    /*}*/
}
</style>



// WEBPACK FOOTER //
// src/common/mFooter.vue